import React from 'react';
import PropTypes from 'prop-types';
import styles from './Button.scss';

const Button = ({
					name,
					value,
					onClick,
					className,
					disabled,
					ariaLabel,
					title,
					id,
					testId,
					analyticsType,
					analyticsPositionIndex,
					analyticsText
				}) => {
	const classNameInner = (className === "") ? styles.btnPrimary : className;

	if (!analyticsText) {
		analyticsText = value;
	}

	return (
		<input
			type="button"
			name={name}
			value={value}
			onClick={onClick}
			className={`${classNameInner}`}
			id={id}
			disabled={disabled}
			title={title}
			data-test={testId}
			aria-label={ariaLabel}
			data-elements-text={analyticsText}
			data-elements-content={analyticsType}
			data-elements-position={analyticsPositionIndex}
		/>
	);
};
Button.defaultProps = {
	className: "",
	name: Math.random().toString(36).substring(7)
};

//
Button.propTypes = {
	name: PropTypes.string,
	onClick: PropTypes.func.isRequired,
	value: PropTypes.string,
	className: PropTypes.string,
	id: PropTypes.string,
	testId: PropTypes.string,
	ariaLabel: PropTypes.string,
	title: PropTypes.string,
	disabled: PropTypes.bool,
	analyticsText: PropTypes.string,
	analyticsPositionIndex: PropTypes.number,
	analyticsType: PropTypes.string,
};

export default Button;
export {styles as buttons};
